export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5254.7440ec48.jpg";